import { z } from 'zod';
import { optionalMongoObjectId } from './object-id-helpers.js';

export const UnitSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1),
    parent: z.string().optional().nullable(), // Parent unit ID
    company: optionalMongoObjectId,
    description: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
});

/** Server computes `level` from parent; never accept from client on write. */
export const CreateUnitSchema = UnitSchema.omit({ id: true });
export const UpdateUnitSchema = UnitSchema;
export const UnitFormSchema = UnitSchema;

export const UnitTransferSchema = z.object({
    unitIds: z.array(z.union([z.string(), z.number()])).min(1),
    newParentId: z.union([z.string(), z.number()]).nullable().optional()
});